/*
 * @description: Don't description
 * @Author: Mustafa.Yin
 * @Date: 2022-05-15 19:22:54
 * @FilePath: \smart-reco-xnd:\vue_project\smart-reco-portal\src\main.js
 * @LastEditTime: 2025-01-05 21:19:38
 */
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/tailwind.css'
import loadingViewerVue from 'loading-viewer-vue'
import { Dialog } from 'vant'
import { Icon } from 'vant'
import { BonreeStart, BonreeVUE } from './utils/BonreeSDK_JS.esm.js'
import { initUserSessionId } from './utils/sessionManager'
import logger from './utils/logger'

// 生产环境开启前端 error 日志自动上报（复用后端问题记录通道），便于运营全链路排障
if (process.env.NODE_ENV === 'production') {
    logger.enableReport()
}
// 全局兜底：未捕获异常统一走 logger（带 userSessionId 上下文）
window.addEventListener('unhandledrejection', (event) => {
    logger.error('global', '未处理的 Promise 异常', event.reason)
})
window.addEventListener('error', (event) => {
    logger.error('global', '未捕获的脚本异常', event.message, event.filename, event.lineno)
})

// 初始化会话标识（userSessionId），全链路日志关联的起点
initUserSessionId()

createApp(App).use(router).use(store).use(Vant).use(loadingViewerVue,{mode:'2'}).use(Dialog).use(Icon).mount('#app')
BonreeStart({
    "reqHeaderTraceKey": [
        "tracestate",
        "traceparent"
    ],
    "uploadAddrHttps": "https://oneupload.bonree.com/RUM/upload",
    "mc": [
        {
            "n": "network",
            "cs": {
                "fc": 0
            }
        }
    ],
    "appId": "c68db396022e4780a81b21828db4f3b3",
    "uploadAddrHttp": "http://oneupload.bonree.com/RUM/upload",
    "respHeaderTraceKey": [
        "traceresponse",
        "x-br-response"
    ],
    "brss": false
})

Date.prototype.Format = function (fmt) {
    const o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'h+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        'S': this.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
}